"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var ClerkApp_exports = {};
__export(ClerkApp_exports, {
  ClerkApp: () => ClerkApp
});
module.exports = __toCommonJS(ClerkApp_exports);
var import_react = require("@remix-run/react");
var import_react2 = __toESM(require("react"));
var import_utils = require("../utils");
var import_RemixClerkProvider = require("./RemixClerkProvider");
function ClerkApp(App, opts = {}) {
  return () => {
    let clerkState;
    const isSpaMode = (0, import_utils.inSpaMode)();
    if (!isSpaMode) {
      const loaderData = (0, import_react.useLoaderData)();
      clerkState = loaderData.clerkState;
    }
    if (isSpaMode) {
      (0, import_utils.assertPublishableKeyInSpaMode)(opts.publishableKey);
    }
    return /* @__PURE__ */ import_react2.default.createElement(
      import_RemixClerkProvider.ClerkProvider,
      {
        ...opts,
        clerkState
      },
      /* @__PURE__ */ import_react2.default.createElement(App, null)
    );
  };
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ClerkApp
});
//# sourceMappingURL=ClerkApp.js.map